import dayHeaderCalendarIcon from './day-header-calendar-icon.png';

export const ImgApi = {
  dayHeaderCalendarIcon
}